var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.025 15.6834C11.8667 15.6834 11.7083 15.6251 11.5833 15.5001C11.3417 15.2584 11.3417 14.8584 11.5833 14.6168L16.2 10.0001L11.5833 5.38343C11.3417 5.14176 11.3417 4.74176 11.5833 4.5001C11.825 4.25843 12.225 4.25843 12.4667 4.5001L17.525 9.55843C17.7667 9.8001 17.7667 10.2001 17.525 10.4418L12.4667 15.5001C12.3417 15.6251 12.1834 15.6834 12.025 15.6834Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9417 10.625H2.91669C2.57502 10.625 2.29169 10.3417 2.29169 10C2.29169 9.65833 2.57502 9.375 2.91669 9.375H16.9417C17.2834 9.375 17.5667 9.65833 17.5667 10C17.5667 10.3417 17.2834 10.625 16.9417 10.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongRightArrow);
export default __webpack_public_path__ + "static/media/long-right-arrow.ad8f94345c86317415e68beb12cf76e5.svg";
export { ForwardRef as ReactComponent };